var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoute = function SvgRoute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_2496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58329 4.1665H9.94529C12.4847 4.1665 13.7543 4.1665 14.2363 4.62258C14.6529 5.01681 14.8376 5.59757 14.7251 6.16001C14.595 6.81068 13.5584 7.54388 11.4852 9.01028L8.09806 11.4061C6.02488 12.8725 4.98828 13.6057 4.85816 14.2563C4.74567 14.8188 4.93031 15.3995 5.34693 15.7938C5.82891 16.2498 7.09859 16.2498 9.63796 16.2498H10.4166M6.66663 4.1665C6.66663 5.54722 5.54734 6.6665 4.16663 6.6665C2.78591 6.6665 1.66663 5.54722 1.66663 4.1665C1.66663 2.78579 2.78591 1.6665 4.16663 1.6665C5.54734 1.6665 6.66663 2.78579 6.66663 4.1665ZM18.3333 15.8332C18.3333 17.2139 17.214 18.3332 15.8333 18.3332C14.4526 18.3332 13.3333 17.2139 13.3333 15.8332C13.3333 14.4525 14.4526 13.3332 15.8333 13.3332C17.214 13.3332 18.3333 14.4525 18.3333 15.8332Z",
    stroke: "#2D4C5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_2496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgRoute;